import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { PaginationResponse } from "@/core/services/api/interfaces/PaginationResponse";
import ApiService from "@/core/services/ApiService";
import { AxiosRequestConfig } from "axios";
import { Integrity } from "@/core/services/api/interfaces/admin/Integrity";

@Module
export default class IntegritiesModule extends VuexModule {
  pagination = new PaginationResponse<Integrity>();
  loading = false;

  get integrities(): Integrity[] {
    return this.integritiesPagination.data;
  }

  get integritiesLoading(): boolean {
    return this.loading;
  }

  get integritiesPagination(): PaginationResponse<Integrity> {
    return this.pagination;
  }

  get integritiesTotal(): number {
    return this.pagination.total;
  }

  get integritiesRequired(): boolean {
    return !this.pagination.total && !this.loading;
  }

  get integritiesCurrentPage(): number {
    return this.pagination.current_page;
  }

  get integritiesPerPage(): number {
    return this.pagination.per_page;
  }

  @Action({ rawError: true })
  [Actions.ADMIN_BANK_ACCOUNT_INTEGRITIES_LOAD](params) {
    this.context.commit(
      Mutations.ADMIN_BANK_ACCOUNT_INTEGRITIES_SET_LOADING,
      true
    );
    return ApiService.admin.bank_account
      .integrities({
        params: params,
      } as AxiosRequestConfig)
      .then(ApiService.unwrapPaginationResponse)
      .then((response) => {
        this.context.commit(
          Mutations.ADMIN_BANK_ACCOUNT_INTEGRITIES_SET,
          response
        );
      })
      .catch(console.error)
      .finally(() =>
        this.context.commit(
          Mutations.ADMIN_BANK_ACCOUNT_INTEGRITIES_SET_LOADING,
          false
        )
      );
  }

  @Action({ rawError: true })
  [Actions.ADMIN_BANK_ACCOUNT_INTEGRITIES_RUN](params) {
    return ApiService.admin.bank_account
      .runIntegrity(params.bank_account_id)
      .then(() =>
        this.context.dispatch(
          Actions.ADMIN_BANK_ACCOUNT_INTEGRITIES_LOAD,
          params
        )
      )
      .catch(console.error);
  }

  @Mutation
  [Mutations.ADMIN_BANK_ACCOUNT_INTEGRITIES_SET](
    pagination: PaginationResponse<Integrity>
  ) {
    this.pagination = pagination;
  }

  @Mutation
  [Mutations.ADMIN_BANK_ACCOUNT_INTEGRITIES_SET_LOADING](loading: boolean) {
    this.loading = loading;
  }
}
